import { ICanvasRenderOptions, IDraw2D } from "./abstraction/IDraw2D";
import { IDraw2DLayer } from "./abstraction/IDraw2DLayer";
import { IViewHost } from "./abstraction/IViewHost";

export class CanvasViewLayer implements IDraw2DLayer {

    protected _host: IViewHost;
    protected _canvas: HTMLCanvasElement;
    protected _draws: IDraw2D[] = [];


    attach(host: IViewHost) {

        this._host = host;

        this._canvas = document.createElement("canvas");
        this._canvas.style.position = "absolute";

        if (host.container.lastElementChild?.classList.contains("controls"))
            host.container.insertBefore(this._canvas, host.container.lastElementChild);
        else
            host.container.appendChild(this._canvas);

        host.requestRenderAsync();
    }

    detach() {
        this._host = undefined;
    }

    protected prepareCanvas() {

        const size = {
            width: this._host.container.clientWidth,
            height: this._host.container.clientHeight
        }

        if (!size.width || !size.height)
            return;

        const newWidth = Math.round(size.width * window.devicePixelRatio);
        const newHeight = Math.round(size.height * window.devicePixelRatio);

        if (newWidth != this._canvas.width) {
            this._canvas.width = newWidth;
            this._canvas.style.width = size.width + "px";
        }

        if (newHeight != this._canvas.height) {
            this._canvas.height = newHeight;
            this._canvas.style.height = size.height + "px";
        }
    }

    protected render2D() {

        const ctx = this._canvas.getContext("2d");

        const p1 = this._host.viewTransform.transformPoint({ x: 0, y: 0 });
        const p2 = this._host.viewTransform.transformPoint({ x: 1, y: 1 });


        const options: ICanvasRenderOptions = {
            viewTransform: this._host.viewTransform,
            viewRect: this._host.viewRect,
            viewScale: {
                x: Math.abs(p2.x - p1.x),
                y: Math.abs(p2.y - p1.y),
            },
            viewSize: this._host.getViewSize(),
            layer: this
        };

        ctx.resetTransform();

        ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);

        ctx.setTransform(options.viewTransform);

        for (const draw of this.draws) {

            if (draw.visible === undefined || draw.visible)
                draw.draw2D(ctx, options);
        }
        

    }

    requestRender() {

        this._host?.requestRenderAsync(this);
    }

    render() {

        this.isRendering = true;

        this.prepareCanvas();
        this.render2D();

        this.isRendering = false;
    }

    clear() {
        for (const draw of this._draws) {

        }
     
        this._draws = [];
    }

    addDraw<T extends IDraw2D>(draw: T) {

        this._draws.push(draw);

        draw.attach(this);

        return draw;
    }

    get draws() {
        return this._draws;
    }

    get host() {
        return this._host;
    }

    isRendering: boolean;
}